'use client';

// Neural mesh background for AI-themed sections

export default function NeuralBackground({ className = '' }: { className?: string }) {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      {/* Base gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50/30 to-cyan-50/20" />

      {/* Animated gradient orbs */}
      <div className="absolute -top-40 -left-40 w-80 h-80 bg-blue-400/20 rounded-full blur-3xl animate-blob" />
      <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-cyan-400/20 rounded-full blur-3xl animate-blob animation-delay-2000" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl animate-blob animation-delay-4000" />

      {/* Neural grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            radial-gradient(circle at 1px 1px, #0D60E6 1px, transparent 0)
          `,
          backgroundSize: '40px 40px'
        }}
      />

      {/* Floating connection lines */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.04]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0D60E6" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        {/* Random neural connection lines */}
        <line x1="10%" y1="20%" x2="30%" y2="40%" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="70%" y1="10%" x2="90%" y2="30%" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="20%" y1="80%" x2="40%" y2="60%" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="60%" y1="70%" x2="80%" y2="90%" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="50%" y1="20%" x2="70%" y2="50%" stroke="url(#lineGrad)" strokeWidth="1" />
        <circle cx="10%" cy="20%" r="3" fill="#0D60E6" opacity="0.3" />
        <circle cx="30%" cy="40%" r="3" fill="#0D60E6" opacity="0.3" />
        <circle cx="70%" cy="10%" r="3" fill="#06b6d4" opacity="0.3" />
        <circle cx="90%" cy="30%" r="3" fill="#06b6d4" opacity="0.3" />
        <circle cx="50%" cy="20%" r="3" fill="#0D60E6" opacity="0.3" />
      </svg>
    </div>
  );
}
